/*
 * WHAT IS CHANGED AND NOT SAVED, on any screen (organiser, 3 Nov 2026: «я
 * змінив, а кнопка нижче… і не помітив, що я щось не зберіг» — «треба цю
 * логіку добавити скрізь, де є можливість»).
 *
 * A form that has a «Зберегти» registers here while its values differ from
 * the saved ones (`useUnsavedChanges`); `UnsavedChangesBar` — one, in App —
 * shows a floating notice at the top of the window with a «Зберегти» for
 * each, and the browser asks before the page is closed or reloaded. Like
 * `saveTracker`, a plain store anything may subscribe to: no provider to
 * forget.
 */
let entries = {};
const listeners = new Set();

const publish = () => {
    const list = Object.values(entries);
    listeners.forEach(listener => listener(list));
};

/** `{id, label, onSave?, saving?}` — the same id again replaces it. */
export const markUnsaved = entry => {
    entries = { ...entries, [entry.id]: entry };
    publish();
};

export const markSaved = id => {
    if (!entries[id]) {
        return;
    }
    const { [id]: gone, ...rest } = entries; // eslint-disable-line no-unused-vars
    entries = rest;
    publish();
};

export const unsavedEntries = () => Object.values(entries);

export const subscribeUnsaved = listener => {
    listeners.add(listener);
    listener(Object.values(entries));

    return () => listeners.delete(listener);
};
